import * as XLSX from "xlsx";

/**
 * Generate Validation Error XLSX File
 */
const downloadValidationErrorFile = (validationErrors) => {
  // Convert data to worksheet format
  const worksheetData = validationErrors.map((item) => ({
    "Row #": item.rowNumber,
    "Error Reason": item.reason,
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);

  // Set column widths
  worksheet["!cols"] = [
    { wch: 10 }, // Row #
    { wch: 80 }, // Error Reason
  ];

  // Create workbook
  const workbook = XLSX.utils.book_new();

  // Append worksheet
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Validation Errors"
  );

  // Generate & Download file
  XLSX.writeFile(
    workbook,
    `validation-errors-${Date.now()}.xlsx`
  );
};

export default downloadValidationErrorFile;